import { MedicationRequestDosageInstructionAdministrationCode } from '@quromedical/fhir-common';
import { strings } from 'strings';

export const dosageInstructionAdministrationDisplay: Record<
  MedicationRequestDosageInstructionAdministrationCode,
  string
> = {
  [MedicationRequestDosageInstructionAdministrationCode.Buccal]:
    strings.MedicationRequestDosageInstructionAdministrationBuccal,
  [MedicationRequestDosageInstructionAdministrationCode.Inhalation]:
    strings.MedicationRequestDosageInstructionAdministrationInhalation,
  [MedicationRequestDosageInstructionAdministrationCode.Intramuscular]:
    strings.MedicationRequestDosageInstructionAdministrationIntramuscular,
  [MedicationRequestDosageInstructionAdministrationCode.Intranasal]:
    strings.MedicationRequestDosageInstructionAdministrationIntranasal,
  [MedicationRequestDosageInstructionAdministrationCode.Intravenous]:
    strings.MedicationRequestDosageInstructionAdministrationIntravenous,
  [MedicationRequestDosageInstructionAdministrationCode.Oral]:
    strings.MedicationRequestDosageInstructionAdministrationOral,
  [MedicationRequestDosageInstructionAdministrationCode.Rectal]:
    strings.MedicationRequestDosageInstructionAdministrationRectal,
  [MedicationRequestDosageInstructionAdministrationCode.Subcutaneous]:
    strings.MedicationRequestDosageInstructionAdministrationSubcutaneous,
  [MedicationRequestDosageInstructionAdministrationCode.Sublingual]:
    strings.MedicationRequestDosageInstructionAdministrationSublingual,
  [MedicationRequestDosageInstructionAdministrationCode.Topical]:
    strings.MedicationRequestDosageInstructionAdministrationTopical,
  [MedicationRequestDosageInstructionAdministrationCode.Transdermal]:
    strings.MedicationRequestDosageInstructionAdministrationTransdermal,
  [MedicationRequestDosageInstructionAdministrationCode.Vaginal]:
    strings.MedicationRequestDosageInstructionAdministrationVaginal,
};
